import axios from "axios";

console.log(process.env.NODE_ENV);
export default process.env.NODE_ENV === "production"
    ? axios.create({
        //production 환경 (AWS EC2)
        baseURL: "https://was.philipk.im",
    })
    : process.env.NODE_ENV === "development"
    ? axios.create({
        //development 환경
        baseURL: "http://52.78.139.236:8603",
    }): axios.create({
        // local 환경
        baseURL: "http://localhost:8603",
    });
